<div class="modal-backdrop">
    <div *ngIf="!showWarning" id="bedcspacingreview">
        <div id="modal-header" class="modal-hr"></div>
        <div class="modal-content text-center padding-10px">
            <h5><strong>Delivery Commitment Re-price</strong></h5>
            <div>
                <p>
                    Due to a change to the DC's Subproduct and/or Note Rate, the DC's price will change from
                    <span style="color:red;font-weight:bold;">
                        {{(originalAgentFeeRate*100).toFixed(8)}}%
                    </span>
                    to
                    <span style="color:green;font-weight:bold;">
                        {{(newAgentFeeRate*100).toFixed(8)}}%
                    </span>
                </p>
            </div>
            <div class="mt-5">
                <p>Do you want to proceed?</p>
                <div class="mt-4 mb-4 button-row">
                    <input type="button" class="btn btn-default blackButton" (click)="onProceed()" value="YES" />
                    <input type="button" class="btn btn-default blackButton" (click)="onCancel()" value="CANCEL" />
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showWarning" id="bedcspacingwarning">
        <div id="modal-header" class="modal-warning"></div>

        <div class="modal-content text-center padding-20px">
            <h5><strong>Warning</strong></h5>
            <p>Are you sure you want to cancel?</p>
            <div class="button-row mt-2">
                <input type="button" class="btn btn-default blackButton" value="YES" (click)="cancelModalYes()" />
                <input type="button" class="btn btn-default blackButton" value="NO" (click)="cancelModalNo()" />
            </div>
        </div>
    </div>
</div>